"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.freighter = void 0;
/* eslint-disable sort-keys-fix/sort-keys-fix */
const freighter_api_1 = __importDefault(require("@stellar/freighter-api"));
function freighter(_) {
    return {
        id: 'freighter',
        name: 'Freighter',
        iconUrl: () => __awaiter(this, void 0, void 0, function* () { return ''; }),
        // iconUrl: async () => (await import('./freighter.svg')).default,
        iconBackground: '#fff',
        // TODO: Check this
        installed: true,
        downloadUrls: {
            browserExtension: 'https://chrome.google.com/webstore/detail/freighter/bcacfldlkkdogcmkkibnjlakofdplcbk?hl=en',
        },
        isConnected() {
            return !!(freighter_api_1.default === null || freighter_api_1.default === void 0 ? void 0 : freighter_api_1.default.isConnected());
        },
        getNetworkDetails() {
            return freighter_api_1.default.getNetworkDetails();
        },
        getPublicKey() {
            return freighter_api_1.default.getPublicKey();
        },
        signTransaction(xdr, opts) {
            return freighter_api_1.default.signTransaction(xdr, opts);
        },
    };
}
exports.freighter = freighter;
;
